import { withTranslation } from 'react-i18next';

import { FILTERS } from './rows';

/**
 * Block 01's record filter: all returned, warnings or errors, pending, or sitemap indexes. It
 * narrows the records already returned, in memory — switching it costs no request and changes
 * nothing about what was fetched. Each view names how many records it holds, so a view that is
 * empty says so before it is picked.
 */
function RecordFilter({ t, filter, counts, onFilter }) {
    return (
        <div className="table-additional-view">
            <div className="table-additional-view-btns">
                <div className="table-additional-view-btn-groups">
                    {FILTERS.map((name) => (
                        <button
                            type="button"
                            key={name}
                            className={filter === name ? 'active' : ''}
                            aria-pressed={filter === name}
                            onClick={() => onFilter(name)}
                        >
                            {t(`tools.sitemap_status.filters.${name}`)} ({counts[name] ?? 0})
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default withTranslation()(RecordFilter);
